module.exports = __webpack_public_path__ + "static/media/add_find_and_show.2cf6f645.svg";